import { createCustomEvent } from './create-custom-event'
import { dispatchCustomEvent } from './dispatch-custom-event'

export const UIEvent = {
  FormChanged: 'FORM_CHANGED',
}

export const dispatchFormChanged = () => dispatchCustomEvent(createCustomEvent(UIEvent.FormChanged))
